import Loader from "components/Shared/Loader";
import { GAME_PLAYER_NOTE_TYPES, PLAYER_NOTE_TYPES } from "config/constants";
import { text_truncate } from "helpers";
import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { usePlayerNoteDispatch } from "store/hooks/playerNotes";

export interface PlayerNoteModalProps {
  show: boolean;
  close: () => void;
  playerId: string;
  teamId: string;
  gameId: string;
  playerName: string;
  playerNoteType?: string;
  playerNote?: string;
  isGame?: boolean
}

const PlayerNoteModal = ({show, close, playerId, teamId, gameId, playerName, playerNoteType, playerNote, isGame}: PlayerNoteModalProps) => {
  const { updatePlayerNote } = usePlayerNoteDispatch();
  const [note, setNote] = useState("");
  const [noteType, setNoteType] = useState<string | number>(0);
  const [charCount, setCharCount] = useState(0);
  useEffect(() => {
    if (playerNote) {
      setNote(playerNote);
      setCharCount(playerNote.length);
    } else {
      setNote("");
      setCharCount(0);
    }
    if (playerNoteType) {
      setNoteType(playerNoteType !== "" ? playerNoteType : 0);
    } else {
      setNoteType(0);
    }
  }, [playerNoteType, playerId, playerNote]);

  const handleChangeNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if ((event.target.value === ' ') || (event.target.value === '\n') ){
      setNote('');
    }else{
      setNote(event.target.value);
      setCharCount(event.target.value.length);
    };
    
  };
  const handleSaveNote = (
    note: string,
    noteType: string,
    gameId: string,
    playerId: string,
    teamId: string
  ) => {
    updatePlayerNote(note, noteType, gameId, playerId, teamId);
  };
  const handleClose = () => {
    setNote(playerNote? playerNote : '');
    setCharCount(playerNote? playerNote.length: 0);
    setNoteType(playerNoteType? playerNoteType: 0);
    close();
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-content-09"
    >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <label
              className="p-01"
              style={{ fontSize: "20px", fontWeight: "bold" }}
            >
              {playerName} Player Note
            </label>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="select-00-note-tag profile-dropdown dropdown" >
            <Dropdown
              style={{ marginBottom: "25px" }}
              onSelect={(event) => {
                setNoteType(event as string);
              }}
            >
              <Dropdown.Toggle id="dropdown-basic" className="btn-gray-l" >
                {noteType === 0
                  ? "Full"
                  : !isGame? 
                      PLAYER_NOTE_TYPES.find((e) => e.value === noteType)?.name
                    :
                      GAME_PLAYER_NOTE_TYPES.find((e) => e.value === noteType)?.name
                    }
              </Dropdown.Toggle>
              <div className="p-b-02">
              <Dropdown.Menu>
                { !isGame? PLAYER_NOTE_TYPES.map((type, index) => (
                  <Dropdown.Item eventKey={type.value} key={"" + index}>
                    {type.name}
                  </Dropdown.Item>
                )):
                GAME_PLAYER_NOTE_TYPES.map((type, index) => (
                  <Dropdown.Item eventKey={type.value} key={"" + index}>
                    {type.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
              </div>
            </Dropdown>

            <textarea
              className="form-control"
              value={note}
              onChange={(e)=>{handleChangeNote(e);}}
              placeholder="Enter Note"
              rows={4}
              maxLength={280}
              style={{resize: 'none'}}
            />
            <p style={{color: charCount===280? 'red':'#007ABA', float:'right' }}>{charCount}/280</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-right footer-s">
          <button className="btn-transparet" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="btn btn-blue"
            onClick={() => {
              close();
              handleSaveNote(
                note,
                noteType as string,
                gameId,
                playerId,
                teamId
              );
            }}
          >
            Save
          </button>
        </Modal.Footer>
    </Modal>
  );
};

export default PlayerNoteModal;
